import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { getMobileOperatingSystem } from '../../lib/common/browser';

/**
 * This page redirects web URLs to mobile app deeplinks.
 *
 * Example:
 * - Input: app.joko.com/deeplink/RedesignedMerchantDetails/%7B%22merchantId%22%3A%22decathlon%22%2C%22region%22%3A%22FR%22%7D?crm_source=...&campaign_id=
 * - Output: joko://RedesignedMerchantDetails/%7B%22merchantId%22%3A%22decathlon%22%2C%22region%22%3A%22FR%22%7D?crm_source=...&campaign_id=
 */
export default function DeeplinkRedirectPage() {
    const location = useLocation();

    React.useEffect(() => {
        // Check if the user is on a mobile device
        const mobileOS = getMobileOperatingSystem();

        if (!mobileOS) {
            // If not on mobile, redirect to the landing page of the web app
            const landingUrl = `/landing/cashback`;
            window.location.replace(landingUrl);
            return;
        }

        // Extract the path after /deeplink/
        // location.pathname will be something like "/deeplink/RedesignedMerchantDetails/..."
        const pathAfterDeeplink = location.pathname.replace(/^\/deeplink\//, '');

        // Preserve query parameters
        const queryString = location.search;

        // Construct the deeplink URL
        const deeplinkUrl = `joko://${pathAfterDeeplink}${queryString}`;

        // Redirect to the deeplink
        window.location.replace(deeplinkUrl);
    }, [location]);

    // Return null since we're redirecting immediately
    return null;
}
